import Vue from 'vue'
import template from './_auth-2fa.pug'
import AuthAppModal from './_auth-app-modal.js'
import EmailModal from './_email-modal.js'
import ProfileService from 'js/services/api/profile'

export default Vue.extend({
  name: 'Auth2FA',
  template: template(),
  components: {
    AuthAppModal,
    EmailModal
  },
  data() {
    return {
      user: null,
      showAuthModal: false,
      showEmailModal: false
    }
  },
  computed: {
    isTOTPEnabled() {
      return this.user?.isTwoFactorTOPTEnabled
    },
    isEmailEnabled() {
      return this.user?.isTwoFactorEmailEnabled
    }
  },
  created() {
    this.fetchUser()
  },
  methods: {
    async fetchUser() {
      try {
        
        const res = await ProfileService.show()
        this.user = res
      } catch (err) {
        console.error('Error al cargar usuario:', err)
      }
    },
    async disable2FA(method) {
      try {
        await ProfileService.toggle2FA({
          enableTwoFactor: false,
          method2faAuth: method
        })
        this.$notifications.success(this.$t('profile.auth2faSettings.successDisabled'))
        await this.fetchUser()
      } catch (err) {
        this.$notifications.error(this.$t('profile.auth2faSettings.errorDisable'))
      }
    }
  }
})
